// extracted by mini-css-extract-plugin
module.exports = {"pending-review":"styles_pending-review__2uYYf","category-popover":"styles_category-popover__1bN6-"};